import React, { useEffect, useState } from 'react'
import Button from '../../../../atoms/Button/Button'
import FormField from '../../../../atoms/FormField/FormField'
import FormRadio from '../../../../atoms/FormRadio/FormRadio'
import FormFile from '../../../../atoms/FormFile/FormFile'
import { trackingCheckout } from '../../../../../utils/gtm'
import { api } from '../../../../../utils'
import useTrans from '../../../../../hooks/useTrans'
import * as Sentry from '@sentry/browser'

const DocumentoTrasporto = ({ setStep, step, props, carrello_main }) => {
  const [documento, setDocumento] = useState(props.values.documento_trasporto)
  const [file_documento, setFile] = useState()
  const t = useTrans()
  useEffect(() => {
    props.setFieldValue('file_documento', file_documento)
  }, [file_documento])
  useEffect(() => {
    props.values.documento_trasporto = documento
  }, [documento])

  useEffect(() => {
    !documento && setDocumento('ts')
  }, [])

  const _handleUpload = (e) => {
    setFile(e.target.files[0])
  }
  return (
    <div className="checkout__documento">
      <FormField className="checkout__formfield">
        <div
          className={'checkout__option' + (documento === 'ts' ? ' checkout__option--selected' : '')}
        >
          <FormRadio
            label={t('Documento di trasporto sipec')}
            size="md"
            checked={!documento || documento === 'ts'}
            onClick={() => setDocumento('ts')}
          />
        </div>
        <div
          style={{ display: 'flex', justifyContent: 'space-between' }}
          className={'checkout__option' + (documento === 'tm' ? ' checkout__option--selected' : '')}
        >
          <FormRadio
            label={t('Documento di trasporto con mia intestazione')}
            size="md"
            checked={documento === 'tm'}
            onClick={() => setDocumento('tm')}
          />

          <div>
            <FormFile
              placeholder={t('Carica Documento')}
              onChange={_handleUpload}
              name={carrello_main?.numero_protocollo}
              filename={file_documento?.name}
            />
          </div>
        </div>
      </FormField>

      {documento && (
        <Button
          disabled={documento === 'tm' ? (file_documento ? false : true) : false}
          label={t('Conferma documento')}
          size="medium"
          variant="primary"
          onClick={() => {
            setStep(step + 1)
            trackingCheckout(carrello_main, 3, documento)
          }}
        />
      )}
    </div>
  )
}

export default DocumentoTrasporto

export const _uploadDocumenti = async ({ id, file_to_upload }) => {
  try {
    await api
      .put(`/ordini/${id}/ddt_file/`, file_to_upload, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Content-Disposition': 'attachment; filename=' + file_to_upload.name,
        },
      })
      .then((res) => {
        console.log(res)
      })
      .catch((err) => {
        console.log(err.message)
        Sentry.captureException(err)
      })
  } catch (error) {
    console.log(error)
  }
}
